import { render, staticRenderFns } from "./SizeGuide.vue?vue&type=template&id=2fe76b3b&scoped=true&"
import script from "./SizeGuide.vue?vue&type=script&lang=js&"
export * from "./SizeGuide.vue?vue&type=script&lang=js&"
import style0 from "./SizeGuide.vue?vue&type=style&index=0&id=2fe76b3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe76b3b",
  null
  
)

export default component.exports